import React, { useState } from "react";
import Backdrop from "./Backdrop";
import Footer from "./Footer";
import Navbar from "./Navbar";

const Layout = ({ children, theme }) => {
  const [navMenuOpen, setNavMenuOpen] = useState(false);

  const toggleNavMenu = (e) => {
    e.preventDefault();
    setNavMenuOpen(!navMenuOpen);
  }

  return (
    <>
      <Navbar
        toggleNavMenu={toggleNavMenu}
        navMenuOpen={navMenuOpen}
        theme={theme}
      />

      <div className={`
        h-[calc(100vh-5rem)]
        ${navMenuOpen ? 'overflow-hidden' : 'overflow-y-scroll overflow-x-hidden'}
      `}>
        <main>
          {children}
        </main>
        <Footer/>
      </div>

      <Backdrop
        onClick={toggleNavMenu}
        navMenuOpen={navMenuOpen}
      />
    </>
  )
};

export default Layout;
